import React from 'react';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';

import { isPeopleFilterActive } from '../../helpers/Files';

const FilesHeaderBackLink = () => {
  const intl = useIntl();

  const getBackLinkUrl = () => {
    if (isPeopleFilterActive()) {
      return '/people';
    }

    return null;
  };

  const getBackLinkText = () => {
    if (isPeopleFilterActive()) {
      return intl.formatMessage({ defaultMessage: 'Back to all People' });
    }

    return null;
  };

  if (!getBackLinkUrl()) {
    return null;
  }

  return (
    <div className="header-back-link-container">
      <Link to={getBackLinkUrl()}>
        <i className="far fa-arrow-left" />
        {getBackLinkText()}
      </Link>
    </div>
  );
};

export default FilesHeaderBackLink;
